import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from 'components/ui/Button';
import { useManagedMutation } from 'utils/managedHooks';
import { sendEmailMutation } from './mutations';

const SendVoucherEmailCTA = ({ voucherAlias }) => {
  const [isSent, setIsSent] = useState(false);
  const [sendEmail, { loading }] = useManagedMutation(sendEmailMutation, {
    variables: {
      voucherAlias
    }
  });

  const processSendEmail = async () => {
    await sendEmail();
    setIsSent(true);
  };

  if (isSent) {
    return (
      <Button disabled icon="TickInCircle">
        <FormattedMessage id="vouchers.sendEmailSuccess" defaultMessage="Email Sent" />
      </Button>
    );
  }

  return (
    <Button disabled={loading} loading={loading} onClick={() => processSendEmail()} icon="RightArrow">
      <FormattedMessage id="vouchers.sendEmail" defaultMessage="Send Email" />
    </Button>
  );
};

SendVoucherEmailCTA.propTypes = {
  voucherAlias: PropTypes.string.isRequired
};

export default SendVoucherEmailCTA;
